import React from "react";
import {createStore} from "redux";
import reducer from "../customizer/lib/reducer";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import CustomLetterCharm from "../customizer/charm";
import UtilsComponent from "../utils/UtilsComponent";
import variantConnector from "../customizer/charm/variant-connector";
import ErrorBoundary from "../utils/ErrorBoundary";

export default function render() {
    const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

    ReactDOM.render(
        <Provider store={store}>
            <ErrorBoundary>
                <>
                    <CustomLetterCharm/>
                    <UtilsComponent/>
                </>
            </ErrorBoundary>
        </Provider>,
        document.getElementById('customizer')
    );

    if (window.location.hostname !== 'localhost') {
        store.subscribe(() => variantConnector(store));
    }
}
